"use strict";

exports.__esModule = true;
exports.SingletonCalendarEventStartTimeField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Time = require("../../Time");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SingletonCalendarEventStartTimeField = exports.SingletonCalendarEventStartTimeField = function SingletonCalendarEventStartTimeField() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: "interval.startMillis"
  }, function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.error ? "danger" : "secondary",
      helperText: meta.error ? meta.error : translate("SingletonCalendarEventStartTimeField.helperText", "The date / time this event starts."),
      label: translate("SingletonCalendarEventStartTimeField.label", "From"),
      labelFor: "interval.startMillis",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_Time.TimestampSelector, {
      selected: [new Date(input.value)],
      onSelect: function onSelect(_ref2) {
        var value = _ref2[0];
        return value && input.onChange(value.getTime());
      }
    }));
  });
};